/* istanbul ignore file */
import React from 'react';
import { Button } from 'framework/ui/mui-builder';
import CloseIcon from '@mui/icons-material/CloseOutlined';
import { useAuthorization } from 'framework/authorization';
import { GROUP_APPLICATION } from 'domain/recruiting/applications/shared/applicationService';

const ApplicationsGroupButton = ({ isActive, onClick }: { isActive: boolean; onClick: () => void }) => {
  const { isGranted } = useAuthorization();

  return isGranted(GROUP_APPLICATION) ? (
    <Button
      onClick={onClick}
      variant={isActive ? 'contained' : 'outlined'}
      sx={{
        b: { marginLeft: '5px' },
        marginRight: isActive ? '12px' : 0,
      }}
    >
      Group by stage
      {isActive && (
        <CloseIcon
          sx={{
            fontSize: '20px',
            marginLeft: '8px',
            marginRight: '-4px',
            color: (theme: any) => theme.vars.palette.common.white,
          }}
        />
      )}
    </Button>
  ) : null;
};

export default ApplicationsGroupButton;
